import { AudiologistCatalogDownloadDTO } from "@bvhi/backend-api";
import { Box, Chip, Stack, Typography } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { compactStringDate } from "../../../../../../../helpers/date";

interface Props {
  download?: AudiologistCatalogDownloadDTO;
}

export const AudiologistCatalogDownloadCell = ({ download }: Props) => {
  const { t } = useTranslation(["audiologists"]);

  const versionDownloaded = typeof download?.versionDownloaded === "string" ? download.versionDownloaded : null;
  const downloadedAt = typeof download?.downloadedAt === "string" ? download.downloadedAt : null;
  const hasDownload = !!versionDownloaded && versionDownloaded.trim() !== "" && !!downloadedAt;

  if (!hasDownload) {
    return (
      <Box alignItems="center" display="flex" sx={{ width: "100%", height: "100%" }}>
        <Typography color="text.secondary" variant="body2">
          {t("audiologists:audiologists.datagrid.catalog.download.not.downloaded")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box alignItems="center" display="flex" py={1} sx={{ width: "100%", height: "100%" }}>
      <Stack spacing={0.5}>
        <Chip color="info" label={versionDownloaded} size="small" variant="outlined" />
        <Typography color="text.secondary" variant="caption">
          {compactStringDate(downloadedAt)}
        </Typography>
      </Stack>
    </Box>
  );
};
